import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { Line, PagedResponseLine } from '../models/Line';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class LineService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getLines():Observable<PagedResponseLine>{
    const data =  this.http.get<PagedResponseLine>(this.APIURL+'/Line' + '?PageNumber=1&PageSize=50');
    this.messageService.add('Line Service: fetched shops');
    return data;
  }
  getLineByCompanyId(companyId: number):Observable<PagedResponseLine>{
    const data = this.http.get<PagedResponseLine>(this.APIURL + '/Line/GetLineByCompanyId/' + companyId);
    this.messageService.add('Line Service: fetched line by companyId');
    return data;
  }

  getNonSupportLineByCompanyId(companyId: number):Observable<PagedResponseLine>{
    const data = this.http.get<PagedResponseLine>(this.APIURL + '/Line/GetNonSupportLineByCompanyId/' + companyId);
    this.messageService.add('Line Service: fetched non support ine by companyId');
    return data;
  }

  getLine(id: number): Observable<Line> {
        const Line =this.http.get<Line>(this.APIURL+'/Line/' + id);
    this.messageService.add(`Line Service: fetched line with id=${id}`);
    return Line;
  }
}